module.exports = __webpack_public_path__ + "img/xmasParty4.ad573d63.jpg";